import { Document, Page, View, StyleSheet, Text, Image, Font } from "@react-pdf/renderer";
import imgKkp from '../../../assets/images/logo_kkp.jpg'
import srcArial from '../../../assets/custom/font/arial/arial.ttf'
import srcArialBold from '../../../assets/custom/font/arial/ARIBL0.ttf'
import { useCallback, useEffect, useMemo, useState } from "react";
import KapalService from "../../../services/kapal/KapalService";
import { formatDateStringLocalDateINA, formatHariTanggalNarasiINA } from "../../../utilities/Utils";
import UserService from "../../../services/user/UserService";
import PelabuhanPendaratan from "../../../utilities/kapal/PelabuhanPendaratan";

Font.register({ family: 'Arial', src: srcArial })
Font.register({ family: 'Arial-Bold', src: srcArialBold })
Font.registerHyphenationCallback(word => [word])

const styles = StyleSheet.create({
    page: {
        paddingTop: 20,
        paddingBottom: 48,
        paddingHorizontal: 42,
        boxSizing: "border-box"
    },
    headingImg: {
        width: 115,
        height: 100,
    },
    headingTtd: {
        width: 220,
        height: 53,
    },
    table: {
        display: "table",
        width: "auto"
    },
    tableRow: {
        flexDirection: "row",
        flexWrap: "wrap"
    },
    tableCol: {
        borderWidth: 0,
        borderLeftWidth: 0,
        borderTopWidth: 0,
        padding: 1
    },
    text: {
        fontSize: 10,
        fontFamily: "Arial"
    },
    textBold: {
        fontSize: 12,
        fontFamily: "Arial-Bold"
    }
})

const PenagguhanInspeksi = ({ dataDisposisi, dataPpmKapal }) => {
    let kapalService = useMemo(() => new KapalService(), [])
    let userService = useMemo(() => new UserService(), [])
    const [dataSP, setDataSP] = useState(null)
    const [masterKapal, setMasterKapal] = useState(null)
    const [uptData, setUptData] = useState(null)

    const fetchAllData = useCallback(async () => {
        if (!dataPpmKapal?.nomorAjuKapal || !dataDisposisi?.noTugas) {
            return
        }

        try {
            const results = await Promise.allSettled([
                kapalService.getPenugasanByAjuAndIdDisposisi(dataPpmKapal.nomorAjuKapal, 9),
                kapalService.getMasterKapalById(dataPpmKapal.idKapal),
                userService.getUptById(dataPpmKapal.kodeUpt)
            ])

            const [resSP, resMasterKapal, resUpt] = results

            const getData = (res, fallback = []) =>
                res.status === "fulfilled"
                    ? res.value?.data?.data ?? res.value?.data ?? fallback
                    : fallback;

            setDataSP(getData(resSP))
            setMasterKapal(getData(resMasterKapal))
            setUptData(getData(resUpt))

        } catch (error) {

        }
    }, [kapalService, dataDisposisi, dataPpmKapal, userService])

    useEffect(() => {
        let isMounted = true
        if (!dataPpmKapal) {
            return
        }

        const loadData = async () => {
            try {
                await fetchAllData()
            } catch (error) {
                if (isMounted) console.error(error)
            }
        }

        loadData()

        return () => { isMounted = false }
    }, [dataPpmKapal, fetchAllData])

    return (
        <Document>
            <Page size="A4" style={styles.page}>
                <View style={[styles.table, { marginBottom: 3 }]}>
                    <View style={[styles.tableRow, { borderBottom: 2, borderBottomStyle: 'solid' }]}>
                        <View style={[styles.tableCol, { width: '25%' }]}>
                            <Image style={styles.headingImg} src={imgKkp} />
                        </View>
                        <View style={[styles.tableCol, { width: '70%', alignItems: 'center' }]}>
                            <Text style={[styles.textBold, { fontSize: 12, textAlign: 'center', color: '#0000ff' }]}>KEMENTERIAN KELAUTAN DAN PERIKANAN</Text>
                            <Text style={[styles.text, { fontSize: 14, textAlign: 'center', color: '#0000ff' }]}>BADAN PENGENDALIAN DAN PENGAWASAN MUTU</Text>
                            <Text style={[styles.text, { fontSize: 14, textAlign: 'center', color: '#0000ff' }]}>HASIL KELAUTAN DAN PERIKANAN</Text>
                            <Text style={[styles.text, { textAlign: 'center' }]}>JALAN MEDAN MERDEKA TIMUR NO. 16</Text>
                            <Text style={[styles.text, { textAlign: 'center' }]}>JAKARTA 10110, KOTAK POS 4130 JKP 10041</Text>
                            <Text style={[styles.text, { textAlign: 'center' }]}>TELEPON (021) 3519070 (LACAK), FAKSIMILE (021) 3513282</Text>
                            <Text style={[styles.text, { textAlign: 'center' }]}>LAMAN www.kkp.go.id, SUREL bppmhkp@kkp.go.id </Text>
                        </View>
                    </View>
                </View>
                <View style={[styles.table, { marginBottom: 10, marginTop: 10 }]}>
                    <View style={styles.tableRow}>
                        <View style={[styles.tableCol, { width: '100%', alignItems: 'center' }]}>
                            <Text style={[styles.textBold, { fontSize: 12, textAlign: 'center' }]}>SURAT KETERANGAN PENANGGUHAN INSPEKSI</Text>
                        </View>
                    </View>

                </View>

                <View style={styles.table}>
                    <View style={[styles.tableRow, { marginBottom: 10 }]}>
                        <View style={[styles.tableCol, { width: '100%' }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'justify' }]}>
                                Pada {formatHariTanggalNarasiINA(dataDisposisi.tglTugas)}, berdasarkan Surat Perintah nomor {dataSP && dataSP.noTugas} Tanggal {dataSP && formatDateStringLocalDateINA(dataSP.tglTugas)},
                                menyatakan {" "}
                                <Text style={[styles.textBold, { fontSize: 12, }]}>penangguhan</Text>
                                {" "} pelaksanaan kegiatan inspeksi dalam rangka sertifikasi Cara Penanganan Ikan yang Baik di:
                            </Text>
                        </View>
                    </View>
                </View>

                <View style={[styles.table, { marginBottom: 10 }]}>
                    <View style={styles.tableRow}>
                        <View style={[styles.tableCol, { width: '35%' }]}>
                            <Text style={[styles.text, { fontSize: 12, paddingLeft: 30, textAlign: 'left' }]}>Nama Kapal</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '3%' }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>:</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '62%' }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>
                                {dataPpmKapal && dataPpmKapal.namaKapal}
                            </Text>
                        </View>
                    </View>

                    <View style={styles.tableRow}>
                        <View style={[styles.tableCol, { width: '35%' }]}>
                            <Text style={[styles.text, { fontSize: 12, paddingLeft: 30, textAlign: 'left' }]}>Nomor Induk Berusaha</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '3%' }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>:</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '62%' }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>
                                {dataPpmKapal && dataPpmKapal.nib}
                            </Text>
                        </View>
                    </View>

                    <View style={styles.tableRow}>
                        <View style={[styles.tableCol, { width: '35%' }]}>
                            <Text style={[styles.text, { fontSize: 12, paddingLeft: 30, textAlign: 'left' }]}>Alamat</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '3%' }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>:</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '62%' }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>
                                {masterKapal && masterKapal.alamatPemilik}
                            </Text>
                        </View>
                    </View>

                    <View style={styles.tableRow}>
                        <View style={[styles.tableCol, { width: '35%' }]}>
                            <Text style={[styles.text, { fontSize: 12, paddingLeft: 30, textAlign: 'left' }]}>Pelabuhan Pendaratan</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '3%' }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>:</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '62%' }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>
                                {dataPpmKapal && <PelabuhanPendaratan id={dataPpmKapal.tempatPendaratan} />}
                            </Text>
                        </View>
                    </View>

                </View>

                <View style={[styles.table, { marginBottom: 5 }]}>
                    <View style={[styles.tableRow, { marginBottom: 5 }]}>
                        <View style={[styles.tableCol, { width: '100%', alignItems: 'center' }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'justify' }]}>Proses penangguhan dilaksanakan berdasarkan hasil koordinasi bahwa hingga tanggal sebagaimana dimaksud diatas belum diperoleh informasi yang pasti mengenai jadwal sandar dan/atau bongkar kapal di pelabuhan. </Text>
                        </View>
                    </View>

                    <View style={[styles.table, { marginBottom: 5 }]}>
                        <View style={[styles.tableCol, { width: '100%', alignItems: 'center' }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'justify' }]}>Selanjutnya, penjadwalan ulang kegiatan inspeksi akan kami informasikan setelah menerima pemberitahuan
                                resmi terkait jadwal sandar/bongkar kapal dari pemilik atau pengelola operasional kapal.
                                Kami mengharapkan kerja sama Saudara untuk menyampaikan informasi tersebut sesegera mungkin guna kelancaran proses sertifikasi CPIB. </Text>
                        </View>
                    </View>

                    <View style={styles.tableRow}>
                        <View style={[styles.tableCol, { width: '100%', alignItems: 'center' }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'justify' }]}>Demikian surat keterangan penangguhan ini kami sampaikan sebagai bentuk keterbukaan informasi pelayanan.
                                Atas perhatian dan kerja sama Saudara, kami ucapkan terima kasih. </Text>
                        </View>
                    </View>
                </View>


                <View style={styles.table}>
                    <View style={[styles.tableRow]}>
                        <View style={[styles.tableCol, { width: '20%' }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}></Text>
                        </View>
                        <View style={[styles.tableCol, { width: '3%' }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}></Text>
                        </View>
                        <View style={[styles.tableCol, { width: '33%' }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}></Text>
                        </View>
                        <View style={[styles.tableCol, { width: '44%' }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>{uptData && uptData.kota}, {dataDisposisi && formatDateStringLocalDateINA(dataDisposisi.tglTugas)}</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '20%' }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}></Text>
                        </View>
                        <View style={[styles.tableCol, { width: '3%' }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}></Text>
                        </View>
                        <View style={[styles.tableCol, { width: '33%' }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}></Text>
                        </View>
                        <View style={[styles.tableCol, { width: '44%' }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>Kepala UPT</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '56%' }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}></Text>
                        </View>
                        <View style={[styles.tableCol, { width: '44%' }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left', marginTop: 50 }]}>{dataDisposisi && dataDisposisi.nmPejabat}</Text>
                        </View>
                    </View>
                </View>
            </Page>
        </Document>
    )
}

export default PenagguhanInspeksi;